
export const SoftwareTypesEnum = {
    TAX: 'tax',
    ONLINE: 'online',
} as const;
export const SoftwareTypes = Object.values(SoftwareTypesEnum);


export const MajorsEnum = {
    ACCOUNTING: 'Accounting',
    BOOKKEEPING: 'Bookkeeping',
    BUSINESS: 'Business',
    ENTREPRENEURSHIP: 'Entrepreneurship',
    FINANCE: 'Finance',
    OTHER: 'Other',
} as const;
